<div class="mfa-container">
  <div class="mfa-box">
    <div class="logo">
      <img
        src="assets/images/excuela-logo.svg"
        alt="Excuela Logo"
        class="logo-image"
      />
    </div>

    <p class="mfa-title">Verificación por dos factores</p>
    <p class="mfa-description">
      Su cuenta está protegida por verificación de dos pasos. Ingrese el código
      de verificación de su aplicación de autenticación
    </p>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
      <div class="form-field mb-3">
        <p-inputOtp
          id="code"
          formControlName="code"
          [length]="6"
          [integerOnly]="true"
          [autofocus]="true"
          styleClass="w-full h-3rem text-xl"
        ></p-inputOtp>
        <div
          *appFormFieldError="form.get('code'); let errors"
          class="error-message"
        >
          @for (error of errors; track error) {
          <div>{{ error }}</div>
          }
        </div>
      </div>
      <button
        pButton
        type="submit"
        class="p-button-primary w-full"
        [disabled]="form.invalid || submitting"
      >
        {{ submitting ? "Verificando..." : "Iniciar sesión" }}
      </button>
    </form>
  </div>
</div>
